<template>
<div class="x-button-pdf">
    <button :class="`btn btn-lg ${color} waves-effect waves-light`"
            type="button"
            @click="$emit('click')">
        <i :class="icon"></i>
    </button>
    <p>{{ label }}</p>
</div>
</template>

<script>

export default {
    props: {
        'label': {
            default: ''
        },
        'color': {
            default: 'btn-warning'
        },
        'icon': {
            default: 'fa-light fa-print'
        }
    },
}
</script>
